// extracted by mini-css-extract-plugin
export default {"Container":"Projects_Container__D5z1Q","ContainerProjects":"Projects_ContainerProjects__7fZtY","SeparatorEscImg":"Projects_SeparatorEscImg__zLMyO"};